import { useEffect } from 'react';

import { OptimizelyProvider } from '@optimizely/react-sdk';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectFormData } from 'selectors/form';

import { getOptimizelyUserAttributes } from './';

const OptimizelyContainer = ({ optimizelyClient, children }) => {
  const formData = useSelector(selectFormData);

  const user = getOptimizelyUserAttributes(formData);

  useEffect(() => {
    optimizelyClient.setUser(getOptimizelyUserAttributes(formData));
  }, [formData]);

  return (
    <OptimizelyProvider optimizely={optimizelyClient} user={user}>
      {children}
    </OptimizelyProvider>
  );
};

OptimizelyContainer.propTypes = {
  optimizelyClient: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default OptimizelyContainer;
